import React from 'react'
import { Typography, Paper, Box, List, ListItem, ListItemText } from '@mui/material'
import CommunityLayout from '../../components/community/CommunityLayout'

function Guidelines() {
  const rules = [
    {
      title: 'Be Respectful',
      description: 'Treat all community members with respect. No harassment, hate speech, or personal attacks.',
    },
    {
      title: 'Stay On Topic',
      description: 'Keep discussions relevant to supply chain simulation and related topics.',
    },
    {
      title: 'No Spam',
      description: 'Avoid posting repetitive content, advertisements, or unrelated links.',
    },
    {
      title: 'Use Clear Titles',
      description: 'Write descriptive titles for your posts to help others find relevant discussions.',
    },
    {
      title: 'Search Before Posting',
      description: 'Check if your question has already been answered before creating a new post.',
    },
    {
      title: 'Report Issues',
      description: 'Use the report feature if you see content that violates these guidelines.',
    },
  ]

  return (
    <CommunityLayout>
      <Paper elevation={0} sx={{ p: 4, border: 1, borderColor: 'divider' }}>
        <Typography variant="h4" fontWeight={700} sx={{ mb: 2 }}>
          Community Guidelines
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Welcome to the SupplyNet Web community! Please follow these guidelines to keep our community helpful and friendly.
        </Typography>

        <List>
          {rules.map((rule, index) => (
            <ListItem key={index} sx={{ flexDirection: 'column', alignItems: 'flex-start', mb: 2 }}>
              <Typography variant="h6" fontWeight={600} sx={{ mb: 0.5 }}>
                {index + 1}. {rule.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {rule.description}
              </Typography>
            </ListItem>
          ))}
        </List>

        <Box sx={{ mt: 4, p: 3, bgcolor: 'primary.50', borderRadius: 2 }}>
          <Typography variant="body2" fontWeight={600} sx={{ mb: 1 }}>
            Consequences of Violations
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Violations of these guidelines may result in content removal, warnings, or account suspension depending on severity. Moderators have final discretion on enforcement.
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="body2" color="text.secondary">
            Questions about these guidelines? Contact the moderators or email{' '}
            <a href="mailto:divyanshece242@gmail.com">divyanshece242@gmail.com</a>
          </Typography>
        </Box>
      </Paper>
    </CommunityLayout>
  )
}

export default Guidelines